import React, { useEffect, useState, useRef } from "react";
import { ValidationMessage, hasRole } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  NEWS_EDIT,
  NEWS_UPDATE,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN
} from "../../routes/routes";
import { toast } from "react-toastify";
import { NEWS_UPDATED } from "../../constant/constant";
import Select from "react-select";
import { FullPageLoader } from '../../components/common/Loader'; // Import the loader component
import { Image } from "react-bootstrap";
import { memberFormSelectStyles } from "../../constant/selectStyles";

const NewsEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [filter, setFilter] = useState([]);

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
  };

  const auth_user = JSON.parse(localStorage.getItem("user"));
  
  /**   *
   * @param {*} input
   * @param {*} callback
   */

  const submit = async (e) => {
    setLoading(true);
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .put(NEWS_UPDATE + id, requestBody, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(NEWS_UPDATED);
          navigate("/news");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };
  useEffect(() => {
    axios.get(NEWS_EDIT + id).then((res) => {
      if (res.status === 200 && res.data.success) {
        let responseData = res.data.data;
        setForm({
          country_id: responseData?.country_id,
          country_id_selected: responseData?.country_id ? {
            value: Number(responseData?.country_id),
            label: responseData?.country_name,
          } : null,
          state_id: responseData?.state_id,
          state_id_selected: responseData?.state_id ?{
            value: Number(responseData?.state_id),
            label: responseData?.state_name,
          } : null,
          region_id: responseData?.region_id,
          region_id_selected: responseData?.region_id ? {
            value: Number(responseData?.region_id),
            label: responseData?.region_name,
          } : null,
          chapter_id: responseData?.chapter_id,
          chapter_id_selected: responseData?.chapter_id ? {
            value: Number(responseData?.chapter_id),
            label: responseData?.chapter_name,
          } : null,
          title: responseData?.title,
          description: responseData?.description,
          cardImage: responseData.image_path,
          video_path: responseData?.video_path,
        });
      }
    }).finally(() => {
      setLoading(false);
    });

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter
          }
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id, filter]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <h5 className="page-title">News Feed</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li>
                  <Link to={"/news"}>
                    <span>News Feed List</span>
                  </Link>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Edit News Feed</span></li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/news"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Edit News</h5> */}
              </div>
              <div className="card-body app-form-fields">
                <form>
                  <div className="row">

                    {hasRole([1]) &&
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="country_id" className="form-label">
                            Country
                          </label>
                          <Select styles={memberFormSelectStyles}
                            isDisabled={true}
                            name="country_id"
                            isClearable
                            placeholder="All Countries"
                            options={countryOptions}
                            onChange={(selected) => {
                              handleStateClear();
                              setForm({ ...form, country_id: Number(selected?.value), state_id: null, region_id: null, chapter_id: null, country_id_selected: selected, state_id_selected: null, region_id_selected: null, chapter_id_selected: null });
                              setFilter({ ...filter, country_id: selected?.value, state_id: null, region_id: null, chapter_id: null })
                            }}
                            value={form?.country_id_selected}
                          />
                          <ValidationMessage error={errors} name="country_id" />
                        </div>
                      </div>
                    }


                    {hasRole([1, 6]) &&
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="state_id" className="form-label">
                            State
                          </label>
                          <Select styles={memberFormSelectStyles}
                            isDisabled={true}
                            ref={selectStateRef}
                            name="state_id"
                            isClearable
                            placeholder="All States"
                            options={stateOptions}
                            onChange={(selected) => {
                              handleRegionClear();
                              setForm({ ...form, state_id: Number(selected?.value), region_id: null, chapter_id: null, state_id_selected: selected, region_id_selected: null, chapter_id_selected: null });
                              setFilter({ ...filter, state_id: selected?.value, region_id: null, chapter_id: null })
                            }}
                            value={form?.state_id_selected}
                          />
                          <ValidationMessage error={errors} name="state_id" />
                        </div>
                      </div>
                    }


                    {hasRole([1, 6, 7]) &&
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="region_id" className="form-label">
                            Region
                          </label>
                          <Select styles={memberFormSelectStyles}
                            ref={selectRegionRef}
                            options={regionOptions}
                            isDisabled={true}
                            placeholder="All Regions"
                            onChange={(selected) => {
                              handleChapterClear();
                              setForm({ ...form, region_id: Number(selected?.value), chapter_id: "", region_id_selected: selected, chapter_id_selected: null });
                              setFilter({ ...filter, region_id: selected?.value, chapter_id: null })
                            }}
                            value={form?.region_id_selected}
                          />
                          <ValidationMessage error={errors} name="region_id" />
                        </div>
                      </div>
                    }

                    {hasRole([1, 6, 7, 2]) &&
                      <div className="col-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="chapter_id">
                            Chapter
                          </label>
                          <Select styles={memberFormSelectStyles}
                            isDisabled={true}
                            ref={selectChapterRef}
                            name="chapter_id"
                            options={chapterOptions}
                            placeholder="All Chapters"
                            onChange={(selected) => {
                              setForm({ ...form, chapter_id: selected?.value, chapter_id_selected: selected });
                            }}
                            value={form?.chapter_id ? form?.chapter_id_selected : ""}
                          />
                          <ValidationMessage error={errors} name="chapter_id" />
                        </div>
                      </div>
                    }

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="title"
                        >
                          Title<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="title"
                          placeholder="title"
                          onChange={(e) =>
                            setForm({ ...form, title: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, title: e.target.value })
                          }
                          defaultValue={form?.title}
                        />
                        <ValidationMessage error={errors} name="title" />
                      </div>
                    </div>


                    <div className="col-6">
                      <div className="d-flex justify-content-between">
                        <label htmlFor="image_path" className="form-label">
                          News Image(16:9)<span className="text-danger">*</span> (ex. 1920wx1080h)
                        </label>
                        <div className="d-flex gap-3 image-info">
                          <div>
                            <label>Max :</label>
                            <span>2MB</span>
                          </div>
                          {/* <div>
                            <label htmlFor="pixel">Min height*width: </label>
                            <span>430px * 600px</span>
                          </div> */}
                        </div>
                      </div>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/jpeg, image/png, image/jpg"
                        onChange={(e) =>
                          e.target.files.length > 0
                            ? setForm({
                              ...form,
                              image_path: e.target.files[0],
                              cardImage: URL.createObjectURL(e.target.files[0]),
                            })
                            : ""
                        }
                      />

                      <div className="m-3">
                        <Image
                          width={120}
                          height={80}
                          src={form?.cardImage}
                        />
                      </div>
                      <ValidationMessage error={errors} name="image_path" />
                    </div>

                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="description"
                        >
                          News Description <span className="text-danger">*</span>
                        </label>
                        <textarea
                          type="text"
                          className="form-control hide-arrow"
                          id="description"
                          placeholder="News description"
                          rows="6"
                          onChange={(e) =>
                            setForm({ ...form, description: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, description: e.target.value })
                          }
                          defaultValue={form?.description}
                        />
                        <ValidationMessage error={errors} name="description" />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="video_path"
                        >
                          News Url (Youtube Link)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="video_path"
                          placeholder="Video Url"
                          onChange={(e) =>
                            setForm({ ...form, video_path: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, video_path: e.target.value })
                          }
                          defaultValue={form?.video_path}
                        />
                        <ValidationMessage error={errors} name="video_path" />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/news"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        &nbsp; Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsEdit;
